/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { ThemeProvider, responsiveFontSizes } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Provider, useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter, Route, Switch,
} from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Store from '../store';
import Home from '../views/Home';
import Payments from '../views/BackOffice/Payments';
import Packages from '../views/BackOffice/Packages';
import Licenses from '../views/BackOffice/Licenses';
import Reports from '../views/BackOffice/Reports';
import Dashboard from '../views/BackOffice/Dashboard';
import DashboardMovements from '../views/BackOffice/Dashboard/Movements';
import ContractInfo from '../views/BackOffice/Dashboard/ContractInfo';
import Configurations from '../views/BackOffice/Configurations';
import RegisterPurchaseOrder from '../views/RegisterPurchaseOrder';
import StatusOrder from '../views/RegisterPurchaseOrder/StatusOrder';
import ActivatePlan from '../views/RegisterPurchaseOrder/ActivatePlan';
import MyPlan from '../views/MyPlan';
import SummaryOrder from '../views/SummaryOrder';
import ManagerExt from '../components/crosscutting/Cart/ManagerExt';
import CartModalExt from '../components/crosscutting/Cart/CartModalExt';
import AddCartExt from '../components/crosscutting/Cart/AddCartExt';
import CartMenuExt from '../components/crosscutting/Cart/CartMenuExt';
import RegisterPurchaseExt from '../components/crosscutting/Cart/RegisterPurchaseExt';
import ReportView from '../components/crosscutting/ReportView';
import { getFullToken, setInfoToken, isAuthenticatedUser } from '../actions/auth.action';
import { getParametersMarketAction } from '../actions/general.action';
import { invokeInterceptor } from '../actions/UnauthorizedResponseInterceptor.action';
import { SET_APP_NAME, SET_TENANT } from '../types/general.type';
import MasterPage from '../components/crosscutting/MasterPage/MasterPage.component';
import MasterPageMarketPlace from '../components/marketPlace/MasterPage';
import GenericMessage from '../components/crosscutting/Cart/GenericMessage';
import Agreements from '../views/BackOffice/Agreements/index';
import MarketPlace from '../views/MarketPlace/index';
import LicenseAssignment from '../views/MarketPlace/LicenseAssignment';
import PaymentResult from '../components/marketPlace/PaymentResult';

const store = (appName, tenant) => {
  const localStore = Store();
  localStore.dispatch({
    type: SET_APP_NAME,
    payload: appName,
  });
  if (tenant !== undefined) {
    localStore.dispatch({
      type: SET_TENANT,
      payload: tenant,
    });
  }
  return localStore;
};

const NavRoute = (props) => {
  const {
    exact, path, computedMatch, component: Component, tenant,
  } = props;
  const dispatch = useDispatch();
  const { token } = computedMatch.params;
  const appsUserToken = sessionStorage.getItem('appsUserToken');
  const userInfo = useSelector(({ auth }) => auth.userInfo);
  if (appsUserToken && !userInfo) {
    dispatch(setInfoToken(appsUserToken));
  }
  if (token) {
    dispatch(getFullToken(token, path));
  }
  const appName = useSelector(({ general }) => general.appName);
  if (tenant !== null && tenant !== undefined) {
    dispatch(getParametersMarketAction('', 'ParametersMarketPlace'))
      .then((res) => {
        let urlFinalRedireccion = '';
        if (res && Array.isArray(res)) {
          const configuracion = res.find((item) => item.parameterCode === 'URL_Market_Tenant' && item.parameterKey.toUpperCase() === tenant.toUpperCase());
          if (configuracion && configuracion.parameterValue) {
            urlFinalRedireccion = configuracion.parameterValue;
          }
        }
        dispatch(isAuthenticatedUser(appName, tenant, urlFinalRedireccion));
      })
      .catch(() => {
        dispatch(isAuthenticatedUser(appName, tenant, ''));
      });
  } else {
    dispatch(isAuthenticatedUser(appName, tenant, ''));
  }

  dispatch(invokeInterceptor(appName));

  // if (isAccesToRole(userInfo && userInfo.license_role, path, enqueueSnackbar)) {
  return (
    <Route
      exact={exact}
      path={path}
      render={(componentProps) => (
        <>
          <MasterPage component={Component} {...componentProps} myuser={userInfo} />
        </>
      )}
    />
  );
  // }
  // return (
  //   <Redirect to="/" />
  // );
};

const App = ({ appName, tenant, theme }) => (
  <ThemeProvider theme={responsiveFontSizes(theme)}>
    <CssBaseline />
    <SnackbarProvider maxSnack={3}>
      <Provider store={store(appName, tenant)}>
        <BrowserRouter>
          <Switch>
            <NavRoute exact path="/admin/packages" component={Packages} tenant={tenant} />
            <NavRoute exact path="/admin/configurations" component={Configurations} tenant={tenant} />
            <NavRoute exact path="/admin/payments" component={Payments} tenant={tenant} />
            <NavRoute exact path="/admin/licenses" component={Licenses} tenant={tenant} />
            <NavRoute exact path="/admin/reports" component={Reports} tenant={tenant} />
            <NavRoute exact path="/admin/agreements" component={Agreements} tenant={tenant} />
            <NavRoute exact path="/admin/dashboard" component={Dashboard} tenant={tenant} />
            <NavRoute exact path="/admin/dashboard/movements" component={DashboardMovements} tenant={tenant} />
            <NavRoute exact path="/admin/dashboard/contractInfo" component={ContractInfo} tenant={tenant} />
            <NavRoute exact path="/myplan" component={MyPlan} tenant={tenant} />
            <NavRoute exact path="/registerPurchaseOrder" component={RegisterPurchaseOrder} tenant={tenant} />
            <NavRoute exact path="/registerPurchaseOrder/statusOrder/:refererenceUuid" component={StatusOrder} tenant={tenant} />
            <NavRoute exact path="/registerPurchaseOrder/activatePlan" component={ActivatePlan} tenant={tenant} />
            <NavRoute exact path="/myplan/:token?" component={MyPlan} tenant={tenant} />
            <NavRoute exact path="/summaryorder/:refererenceUuid" component={SummaryOrder} tenant={tenant} />
            <NavRoute exact path="/license/addCartItem/:idParam" component={ManagerExt} tenant={tenant} />
            <Route exact path="/license/viewCartMenu" component={CartMenuExt} />
            <Route exact path="/license/viewCartModal/:idParam?/:quantityParam?/:reloadParam?" component={CartModalExt} />
            <Route exact path="/license/addCart/:encryptedParameter+" component={AddCartExt} />
            <Route exact path="/license/RegisterPurchaseExt" component={RegisterPurchaseExt} />
            <Route exact path="/license/reports/reportView" component={ReportView} />
            <Route exact path="/messageValidationEmail" component={GenericMessage} />
            <Route exact path="/cart" render={(routeProps) => <MasterPageMarketPlace component={MarketPlace} appName={appName} tenant={tenant} {...routeProps} />} />
            <Route
              exact
              path="/license-assignment"
              render={(routeProps) => (
                <MasterPageMarketPlace
                  component={LicenseAssignment}
                  appName={appName}
                  tenant={tenant}
                  isAssignment
                  {...routeProps}
                />
              )}
            />
            <Route
              exact
              path="/result-payment"
              render={(routeProps) => (
                <MasterPageMarketPlace
                  component={PaymentResult}
                  appName={appName}
                  tenant={tenant}
                  isAssignment
                  hasResult
                  {...routeProps}
                />
              )}
            />
            {/* Rutas más generales al final */}
            <NavRoute exact path="/cart/:packageId" component={Home} tenant={tenant} />
            <NavRoute exact path="/:token?" component={appName === 'license' ? Configurations : Home} tenant={tenant} />
          </Switch>
        </BrowserRouter>
      </Provider>
    </SnackbarProvider>
  </ThemeProvider>
);
export default App;
